import { PopulationBasedFundingHelper } from "@/Common/Helpers/PopulationBasedFundingHelper";
import { PopulationBasedFundingEventOverrideReason } from "@/Common/Models/UI/Enums";

class PopulationBasedFundingOverrideReasonUIModel {
    constructor(overrideReason: PopulationBasedFundingEventOverrideReason) {
        this.Enum = overrideReason;
        this.VocabKey = PopulationBasedFundingHelper.getOverrideReasonVocabKey(overrideReason);
    }

    public VocabKey: string;
    public Enum: PopulationBasedFundingEventOverrideReason;
}

export { PopulationBasedFundingOverrideReasonUIModel };
